// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"248":"ba391f47","478":"0f31dd8b","498":"9f4972c3","513":"2824d3f3","703":"17fa1254","719":"0aa5aa3d","787":"6f0feef4"}[chunkId] + ".chunk.js";
};